/**
 * Organization-specific detection hooks for PolicyStream (e.g. slug checks).
 * Hooks like `useUsingVagoSettings` live elsewhere today; new hooks of this kind
 * should be added here rather than scattered across the codebase.
 */
import { generateUseUseSettings } from '../../../hooks/generateUseUsingSettings';

/** David Broudie / Broudie Insurance — WL row slug from the backend. */
export const useUsingBroudieInsurance = generateUseUseSettings({
  slug: 'davidbroudie',
});
